import type { CloseFromEnum } from '@meitu/saas-subscription-popup';
import { IdentityType } from '@/types';
import { TeamTagType } from '../teamTag';

/** 获取团队标签 */
export function getTeamTagType(oid: number, type: number) {
    if (oid === 0) return TeamTagType.personal;
    if (type === IdentityType.TEAM) return TeamTagType.team;
    if (type === IdentityType.ENTERPRISE) return TeamTagType.enterprise;
    return TeamTagType.free;
}

export type TypeOpenVipTeamModal = (
    params?: {
        entrance?: string;
        second_source?: string;
        oid?: number;
        groupId?: number;
        purchase_scene?: string;
        subscribe_type?: string;
        [k: string]: any;
    },
    closeVipModalCallback?: (from?: CloseFromEnum) => void,
    payVipModalCallback?: () => void,
) => void;

export type TypeTrack = (
    eventName: string,
    args: {
        [key: string]: string | number;
    },
) => void;
